var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home_topic"},_vm._l((_vm.moduleList),function(item,index){return _c('div',{key:_vm.i,staticClass:"topic-item",on:{"click":function($event){return _vm.activityTo(item)}}},[_c('img',{staticClass:"topic-item-icon",attrs:{"src":item.photo}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc2bef0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/home/child/HomeTopic.vue
// module id = null
// module chunks = 